import type { GetPartenairesQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { partenaires } from '~/msw/mocks/diffusion'

export function getPartenairesHandler() {
  return http.get<
    { officeOid: string },
    never,
    GetPartenairesQueryResponse
  >('http://localhost:3000/api/v1/partenaires/:officeOid', () => {
    return HttpResponse.json(partenaires)
  })
}
